module.exports = __webpack_public_path__ + "createstatic/media/publishIcn.58e0416d.svg";